import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ISimpleEventResponse } from '@/src/v2/service/v2/graphql/generated/gql-api.generated';

type FeaturedEvent = {
  events: ISimpleEventResponse[];
  defaultList: ISimpleEventResponse[] | null;
};
const initialState: FeaturedEvent = {
  events: [],
  defaultList: null,
};
const FeaturedEvent = createSlice({
  name: 'FeaturedEvent',
  initialState,
  reducers: {
    setEvent: (
      state: FeaturedEvent,
      action: PayloadAction<ISimpleEventResponse[] | []>
    ) => {
      state.events = action.payload;
    },
    setDefaultEvent: (
      state: FeaturedEvent,
      action: PayloadAction<ISimpleEventResponse[] | null>
    ) => {
      state.defaultList = action.payload;
    },
    updateFeaturedEvent: (
      state: FeaturedEvent,
      action: PayloadAction<ISimpleEventResponse[] | null>
    ) => {
      state.events = action.payload;
    },
  },
});

export const { setEvent, setDefaultEvent, updateFeaturedEvent } =
  FeaturedEvent.actions;

export default FeaturedEvent.reducer;
